import {Language} from "./types";

export enum InAppMessageType {
  Modal = 'modal',
  LoginScreenBanner = 'loginScreenBanner',
  PayoutSystemStatus = 'payoutSystemStatus'
}

export enum InAppMessageSeverity {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Critical = 'critical'
}

export interface InAppMessage {
  id: string
  internalName: string
  icon: string
  url: string | undefined
  validFrom: string
  validTo: string | undefined
  sticky: boolean
  minAppVersion: string
  priority: number
  published: boolean
  readCount: number
  translations: InAppMessageTranslation[]
  type: InAppMessageType
  severity: InAppMessageSeverity
  audience?: AudienceModel
}

export interface CreateOrUpdateInAppMessageModel {
  internalName: string
  icon: string
  url: string | undefined
  validFrom: string
  validTo: string | undefined
  sticky: boolean
  minAppVersion: string
  priority: number
  type: InAppMessageType
  severity: InAppMessageSeverity
}

export interface InAppMessageTranslation {
  type: string
  title: string
  description: string
  buttonText: string
  language: Language
}

////////////
/// Audience
////////////
type AllUsersAudienceModel = {
  type: 'allUsers',
}

type EmployerAudienceModel = {
  type: 'employer',
  employers: EmployerAudienceMember[]
}

export interface EmployerAudienceMember
{
  id : string
  name : string
}

export type AudienceModel = AllUsersAudienceModel | EmployerAudienceModel

type CreateOrUpdateEmployerAudienceModel = {
  type: 'employer',
  employerIds: string[]
}

type CreateOrUpdateAllUsersAudienceModel = {
  type: 'allUsers',
}

export type CreateOrUpdateAudienceModel = CreateOrUpdateEmployerAudienceModel | CreateOrUpdateAllUsersAudienceModel
